import type { JOB_ADS_STATE_VALUE } from "@/modules/jobAds/client/api/constants"
import type { JobAdsState } from "@/modules/jobAds/client/api/types"

export function isJobAdSavedOrAppliedState({
  jobAdsState,
  id,
  state,
}: {
  id: string
  jobAdsState: JobAdsState
  state: typeof JOB_ADS_STATE_VALUE.SAVED | typeof JOB_ADS_STATE_VALUE.APPLIED
}): boolean {
  return jobAdsState.some(jobAdState => jobAdState.id === id && jobAdState.state === state)
}
